import React from 'react';
export const Testimonials = () => {
  return <section className="py-12 px-4 sm:px-6 md:px-8 max-w-7xl mx-auto bg-[#F8F2EA]" data-id="element-314">
      <h2 className="font-serif text-2xl sm:text-3xl font-bold text-center text-[#0C1B2A] mb-2" data-id="element-315">
        Lo que dicen nuestras lectoras
      </h2>
      <p className="text-center text-[#555555] mb-12 max-w-2xl mx-auto" data-id="element-316">
        Mujeres como tú que han transformado su energía y la de su familia con
        nuestra guía
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-317">
        {/* Testimonial 1 */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-318">
          <div className="flex flex-col items-center mb-4" data-id="element-319">
            <div className="w-20 h-20 rounded-full overflow-hidden mb-3" data-id="element-320">
              <img src="https://images.unsplash.com/photo-1508002366005-75a695ee2d17?q=80&w=1568&auto=format&fit=crop" alt="Foto de Laura M." className="w-full h-full object-cover" data-id="element-321" />
            </div>
            <h3 className="font-serif text-lg font-semibold text-[#0C1B2A]" data-id="element-322">
              Laura M.
            </h3>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#D4AF37] bg-opacity-20 text-[#8B7D29]" data-id="element-323">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-324">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-325" />
              </svg>
              Verificado
            </span>
          </div>
          <div className="text-center" data-id="element-326">
            <svg className="w-8 h-8 text-[#D4AF37] opacity-30 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-327">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-328" />
            </svg>
            <p className="text-[#555555] mb-2" data-id="element-329">
              "La primera noche dormimos en paz. Mi nene dejó de despertarse
              inquieto. La casa se siente liviana."
            </p>
          </div>
        </div>
        {/* Testimonial 2 */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-330">
          <div className="flex flex-col items-center mb-4" data-id="element-331">
            <div className="w-20 h-20 rounded-full overflow-hidden mb-3" data-id="element-332">
              <img src="https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?q=80&w=1374&auto=format&fit=crop" alt="Foto de Andrea M." className="w-full h-full object-cover" data-id="element-333" />
            </div>
            <h3 className="font-serif text-lg font-semibold text-[#0C1B2A]" data-id="element-334">
              Andrea M.
            </h3>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#D4AF37] bg-opacity-20 text-[#8B7D29]" data-id="element-335">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-336">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-337" />
              </svg>
              Verificado
            </span>
          </div>
          <div className="text-center" data-id="element-338">
            <svg className="w-8 h-8 text-[#D4AF37] opacity-30 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-339">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-340" />
            </svg>
            <p className="text-[#555555] mb-2" data-id="element-341">
              "Probé pulseras y nada. Con esta guía entendí cómo activar la
              protección en serio. Otra energía."
            </p>
          </div>
        </div>
        {/* Testimonial 3 */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-342">
          <div className="flex flex-col items-center mb-4" data-id="element-343">
            <div className="w-20 h-20 rounded-full overflow-hidden mb-3" data-id="element-344">
              <img src="https://images.unsplash.com/photo-1554727242-741c14fa561c?q=80&w=1374&auto=format&fit=crop" alt="Foto de Paola R." className="w-full h-full object-cover" data-id="element-345" />
            </div>
            <h3 className="font-serif text-lg font-semibold text-[#0C1B2A]" data-id="element-346">
              Paola R.
            </h3>
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-[#D4AF37] bg-opacity-20 text-[#8B7D29]" data-id="element-347">
              <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20" data-id="element-348">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-349" />
              </svg>
              Verificado
            </span>
          </div>
          <div className="text-center" data-id="element-350">
            <svg className="w-8 h-8 text-[#D4AF37] opacity-30 mx-auto mb-2" fill="currentColor" viewBox="0 0 24 24" data-id="element-351">
              <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-352" />
            </svg>
            <p className="text-[#555555] mb-2" data-id="element-353">
              "A los 7 días noté el cambio en mí y en mis hijos. Volvió la
              calma. No tiene precio."
            </p>
          </div>
        </div>
      </div>
    </section>;
};